import { render } from "./supportView.vue?vue&type=template&id=c059e22a&scoped=true"
import script from "./supportView.vue?vue&type=script&setup=true&lang=js"
export * from "./supportView.vue?vue&type=script&setup=true&lang=js"

import "./supportView.vue?vue&type=style&index=0&id=c059e22a&scoped=true&lang=css"

import exportComponent from "/Users/lukmannakib/.codex/worktrees/a2d0/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c059e22a"],['__file',"resources/views/supportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c059e22a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c059e22a', __exports__)) {
    console.log('reload')
    api.reload('c059e22a', __exports__)
  }
  
  module.hot.accept("./supportView.vue?vue&type=template&id=c059e22a&scoped=true", () => {
    console.log('re-render')
    api.rerender('c059e22a', render)
  })

}


export default __exports__